<template>
  <div class="container">
    <div class="article-slide">
      <swiper
        class="position-relative article-slide__slider"
        add_navigation_buttons
        next_btn_class="image_next_btn"
        prev_btn_class="image_prev_btn"
        :swiper_config="{spaceBetween: 20}"
        :breakpoints="swiper_breakpoints">
        <swiper-slide
          v-for="(article, index) in articles_list"
          :key="`swiper-slide_${index}_${uid}`">
          <preview-article
            class="col-md-3 col-sm-6 col-12 article-slide__item"
            :img_src="article.img_url"
            :title="article.title"
            :title_tag="article_tag"
            :text="article.prev_text"
            :date="article.created_at"
            :href_to="article.link"
            :key="`article-slide_${index}_${uid}`"
          />
        </swiper-slide>
      </swiper>
    </div>
    <div
      v-if="link_to_category"
      class="mt-40 mt-xs-20 text-center">
      <default-button
        :href="link_to_category"
        is_light
        bordered>
        {{$t('btn.see_all_post')}}
      </default-button>
    </div>
  </div>
</template>

<script>


import ssr, {ssr_window} from "../../helpers/ssr";
import Swiper from "../modules/Swiper/Swiper.vue";
import SwiperSlide from "../modules/Swiper/SwiperSlide.vue";
import LazyImage from "../small_parts/LazyImage.vue";
import PreviewArticle, {IMG_LAZY_CLASS} from "../parts/builder/PreviewArticle.vue";
import DefaultButton from "../slots/DefaultButton.vue";
import {CONTEXT} from "../../helpers/constants";

export default {
  name: "ArticleSlide",
  mixins: [ssr],
  components: {
    DefaultButton,
    PreviewArticle,
    LazyImage,
    SwiperSlide,
    Swiper
  },
  props: {
    /**props**/
    article_tag: {
      type: String,
      default: 'h3',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    link_to_category: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    /**props**/
  },
  computed: {
    current_link() {
      return ssr_window?.location?.href
    },
    articles_list() {
      return (CONTEXT?.last_articles || []).filter(el => el.link !== this.current_link)
    },
    uid() {
      return this._uid
    },
    swiper_breakpoints() {
      return {
        576: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      }
    },
  },
}
</script>
